/* src/app/module/password/password.component.scss */
.personal-info h3 {
  margin-bottom: 4px;
}
.personal-info p {
  font-size: 14px;
  color: #6c757d;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0px;
  margin-bottom: 20px;
}
.custom-hr {
  border: none;
  border-top: 1px solid #d1d5db;
  margin: 20px 0;
}
.horizontal-line {
  border-top: 1px solid #d1d5db;
  margin: 1rem 0;
}
.form-row {
  display: flex;
  gap: 1rem;
}
.form-col {
  flex: 1;
}
.formly-field {
  margin-bottom: 1rem;
}
.login-button {
  width: 100%;
  background-color: #ff8c00;
  border: none;
  color: white;
  padding: 0.75rem;
  border-radius: 4px;
  font-size: 1rem;
  margin-top: 17px;
}
label {
  margin-bottom: 6px;
}
:host ::ng-deep .p-error {
  margin-top: 4px;
  display: flex;
  margin-left: 170px;
}
::ng-deep .p-field label {
  margin-right: 34px;
}
:host ::ng-deep .field1 label {
  margin-right: 58px;
}
:host ::ng-deep .field2 label {
  margin-right: 36px;
  margin-left: 5px;
}
:host ::ng-deep .p-inputtext,
.p-dropdown {
  width: 540px !important;
  height: 44px !important;
}
::ng-deep .p-inputtext:focus {
  outline: none !important;
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
  background-color: white !important;
}
::ng-deep .p-inputtext:hover {
  outline: none !important;
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
  background-color: white !important;
}
::ng-deep input:hover,
input:focus {
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
::ng-deep input:-webkit-autofill {
  background-color: white !important;
  box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-text-fill-color: black !important;
}
::ng-deep input .p-focus,
::ng-deep input .p-highlight {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background: #ffffff;
  border-color: #D47500;
  color: #D47500;
  padding: 20px 6px 20px 6px;
}
.save-button {
  border-radius: 5px;
  padding: 0.5rem 1.5rem;
}
.cancel-button {
  background-color: #fff;
  color: #000000;
  border-radius: 8px;
  padding: 0.5rem 1.5rem;
  border: 1px solid #D0D5DD;
  height: 40;
}
.cancel-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.change-password-container {
  padding: 5px;
}
.change-password-container h1 {
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: 500;
}
::ng-deep .p-inputtext {
  margin-top: 4px;
}
/*# sourceMappingURL=password.component-UYFSVKLX.css.map */
